import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { NavLink } from "react-router-dom";
import ModalAccount from './ModalAccount';
import Modal from "./Modal";
import { getColorFromProgress } from "../utils/colorTextUtils";

const MainSearchBar = ({ isNavbarToggled, toggleNavbar, isMobileNavbarToggled, toggleMobileNavbar, screenWidth }) => {
    const [searchText, setSearchText] = useState('');
    const [results, setResults] = useState([]);
    const [modalState, setModalState] = useState(false);
    const [userInfos, setUserInfos] = useState([])

    const searchRef = useRef(null);
    const accountRef = useRef(null);

    // Toggle account modal
    const handleAccountModal = () => {
        setModalState((prev) => !prev);
    };

    // Mirrors the generateDeterministicK logic from access.js using the browser Web Crypto API.
    const generateWpPassword = async (domain) => {
        const salt = 'guinness';
        const encoder = new TextEncoder();
        // Step 1: SHA-256 of domain → hex string
        const firstBuf = await window.crypto.subtle.digest('SHA-256', encoder.encode(domain));
        const firstPass = Array.from(new Uint8Array(firstBuf)).map(b => b.toString(16).padStart(2, '0')).join('');
        // Step 2: SHA-256 of (hex + salt) → base64
        const secondBuf = await window.crypto.subtle.digest('SHA-256', encoder.encode(firstPass + salt));
        const base64 = btoa(String.fromCharCode(...new Uint8Array(secondBuf)));
        // Step 3: translate alphabet, trim to 23 chars + '!'
        const map = { '+': '_', '/': '@', '=': '-' };
        return base64.replace(/[+/=]/g, m => map[m]).substring(0, 23) + '!';
    };

    const handleLogin = async (url) => {
        try {
            const parsedUrl = new URL(url);
            const hostname = parsedUrl.hostname.replace(/^www\./, '');
            // For visu sites: use only the path slug as the key (e.g. 'jdp')
            // This matches how the WP admin passwords were originally generated.
            let domain = hostname;
            if (hostname === 'visu.solution-digitale.ch') {
                const slug = parsedUrl.pathname.split('/').filter(Boolean)[0];
                if (slug) domain = slug;
            }
            const password = await generateWpPassword(domain);
            window.open(
                `${url}/login/?login=true&user=guinness@solution-digitale.ch&pass=${encodeURIComponent(password)}`,
                '_blank'
            );
        } catch (error) {
            console.error('Error logging in:', error);
        }
    };

    // Handle clicks outside both search and account modal
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setResults([]);
            }
            if (accountRef.current && !accountRef.current.contains(event.target)) {
                setModalState(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Handle search input change
    useEffect(() => {

        const user = localStorage.user_id
        axios.post(`${API_BASE_URL}/get_user_infos_by_id`, { user })
            .then((res) => {

                setUserInfos(res.data[0])
            })

        if (searchText.trim() === '') {
            setResults([]);
            return;
        }

        const timer = setTimeout(() => {
            axios.post(`${API_BASE_URL}/search/`, { searchText })
                .then((response) => {
                    setResults(response.data);
                })
                .catch((error) => {
                    console.error('Error fetching search results:', error);
                });
        }, 500);

        return () => clearTimeout(timer);
    }, [searchText]);

    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
    };

    const handleFocus = () => {
        if (searchText.trim() !== '') {
            axios.post(`${API_BASE_URL}/search/`, { searchText })
                .then((response) => {
                    setResults(response.data);
                })
                .catch((error) => {
                    console.error('Error fetching search results on focus:', error);
                });
        }
    };

    return (<div className="">
        <div
            className={`main-searchbar display-flex justify-content-space-between transition-height ${screenWidth >= 1200 && isNavbarToggled ? "main-searchbar-container-contained" : "main-searchbar-container-full"
                }`}
        >
            <div className={"search-container display-flex justify-content-space-between w-100"} style={{ alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    {screenWidth < 1200 ? (
                        <>
                            <button
                                onClick={toggleMobileNavbar}
                                style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    padding: "5px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "var(--primary)",
                                    fontSize: "20px"
                                }}
                            >
                                <i className={`fa-solid ${isMobileNavbarToggled ? 'fa-xmark' : 'fa-bars'}`}></i>
                            </button>
                            <img
                                src={'https://solution-digitale.ch/wp-content/uploads/2021/03/logo-solution-digitale-300-1.png'}
                                style={{ maxWidth: "120px", height: "auto" }}
                                alt={'Logo'}
                            />
                        </>
                    ) : (
                        !isNavbarToggled && (
                            <>
                                <button
                                    onClick={toggleNavbar}
                                    style={{
                                        background: "none",
                                        border: "none",
                                        cursor: "pointer",
                                        padding: "5px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "var(--primary)",
                                        fontSize: "20px"
                                    }}
                                >
                                    <i className="fa-solid fa-chevron-right"></i>
                                </button>
                                <img
                                    src={'https://solution-digitale.ch/wp-content/uploads/2021/03/logo-solution-digitale-300-1.png'}
                                    style={{ maxWidth: "120px", height: "auto" }}
                                    alt={'Logo'}
                                />
                            </>
                        )
                    )}
                    <div className="input-search main-searchbar-for-responsive">
                        <i className="fa-solid fa-magnifying-glass mr-10"></i>
                        <input
                            onChange={handleSearchChange}
                            onFocus={handleFocus}
                            type="search"
                            autoComplete={"off"}
                            className="search-input"
                            placeholder="Rechercher..."
                            value={searchText}
                        />
                    </div>
                </div>

                <div className={"display-flex flex-direction-row align-items-center gap-20"}>
                    <div className={"display-flex"}>
                        {/*

                    Code pour afficher les notifications

                    <span className={"cursor-pointer"} onClick={()=>setModalState((prev) => !prev)}>
                    <i className="fa-regular fa-bell" style={{fontSize: "1.4rem"}}/>
                        {modalState && <Modal />}
                    </span>
*/}
                    </div>
                    <div className="display-flex">
                        <div ref={accountRef} className="">
                            <div
                                onClick={handleAccountModal}
                                className="display-flex align-items-center gap-10 cursor-pointer"
                            >
                                <span className="user-pp"
                                    style={{ backgroundColor: userInfos.color }}>{localStorage.user_name.charAt(0)}</span>
                            </div>
                            {modalState && <ModalAccount toggleModal={() => setModalState(prev => !prev)} />}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className={"searchbar-results-container"}>
            <div ref={searchRef} className={"searchbar-results"}>
                {/* Render search results here */}
                {results.length > 0 && (<div className="search-results">
                    <div className={"p-15"} style={{ overflowY: "scroll", maxHeight: "50vh" }}>
                        {/* Render Customer Results */}
                        {results.some(result => result.type === 'customer') && (<div>
                            <h4 className={"mt-0 color-third  mb-10"}>Clients</h4>

                            {results.filter(result => result.type === 'customer').map((result, index) => (

                                <NavLink className={"text-decoration-none"}

                                    to={`/client/${result.id}`}
                                    key={index}
                                    onClick={() => setResults([])}  // Clear results on click
                                >
                                    <div className={"display-flex gap-10 search-item-found"}>

                                        <div className={"display-flex gap-10 align-items-center"}>
                                            <i className="fa-solid fa-user mr-10 color-third mr-10 text-right"></i>
                                            <strong className={"color-primary"}
                                                dangerouslySetInnerHTML={{ __html: result.name_1 }} />
                                        </div>
                                    </div>
                                </NavLink>))}
                            <hr className={"my-20"} />
                        </div>)

                        }

                        {/* Render Position Results */}
                        {results.some(result => result.type === 'position') && (<div>
                            <h4 className={" mt-0 color-third  mb-10"}>Projets </h4>

                            {results.filter(result => result.type === 'position').map((result, index) => (
                                <NavLink className={"text-decoration-none"}
                                    to={`/positions/${result.id}`}
                                    key={index}
                                    onClick={() => setResults([])}  // Clear results on click
                                >
                                    <div
                                        className={"display-flex gap-10 search-item-found justify-content-space-between align-items-center"}>

                                        <div className={"display-flex gap-10 align-items-center"}>
                                            <i className="fa-solid fa-list-check mr-10 color-third mr-10 text-right"></i>
                                            <span className={"rounded display-flex align-items-center justify-content-center color-third"} style={{ border: "solid", borderWidth: 2, borderColor: getColorFromProgress(result.mail), fontSize: '.7rem', fontWeight: 600, padding: 10, height: 30, width: 30 }}>{(parseInt(result.mail))}</span>
                                            <strong className={"color-primary"}
                                                dangerouslySetInnerHTML={{ __html: result.name_1 }} />
                                        </div>
                                        <i className={"color-third text-right"}
                                            dangerouslySetInnerHTML={{ __html: result.name_2 }} />
                                    </div>
                                </NavLink>

                            ))}
                            <hr className={"my-20"} />
                        </div>)}{/* Render Sites Results */}
                        {results.some(result => result.type === 'website') && (<div>
                            <h4 className={" mt-0 color-third  mb-10"}>
                                Sites internet </h4>


                            {results.filter(result => result.type === 'website').map((result, index) => (

                                <NavLink className={"text-decoration-none"}
                                    to={`${result.url}`}
                                    key={index}
                                    target={"_blank"}
                                    onClick={() => setResults([])}  // Clear results on click
                                >
                                    <div className={""}>

                                        <div
                                            className={"display-flex gap-10 search-item-found justify-content-space-between align-items-center"}>
                                            <div>

                                                <i className={"fa-regular fa-globe-pointer mr-10 color-third"} />
                                                <strong className={"color-primary"}
                                                    dangerouslySetInnerHTML={{ __html: result.url }} />
                                            </div>
                                            <div className={"display-flex gap-10 h-100 "}>
                                                {result.name_2 && (
                                                    <small
                                                        className={"color-third display-flex text-right h-100 p-5 border-radius-5 bg-primary color-white"}
                                                        dangerouslySetInnerHTML={{ __html: result.name_2 }} />
                                                )}
                                                {result.mail && (

                                                    <small
                                                        className={"color-primary display-flex text-right h-100 p-5 border-radius-5 bg-third color-white"}
                                                        dangerouslySetInnerHTML={{ __html: result.mail }} />
                                                )} {result.mail && (


                                                    <small
                                                        className={"align-items-center color-primary display-flex text-right p-5 border-radius-5 bg-third color-white"} style={{ height: 26 }}
                                                        target={"_blank"}
                                                        onClick={() => handleLogin(result.url)}  // Clear results on click
                                                    ><i className={"fas fa-user-shield"} />

                                                    </small>
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                </NavLink>))}

                            <hr className={"my-20"} />
                        </div>)

                        }

                        {results.some(result => result.type === 'website_visu') && (<div>
                            <h4 className={" mt-0 color-third mb-10"}>Visus
                            </h4>

                            {results.filter(result => result.type === 'website_visu').map((result, index) => (

                                <NavLink className={"text-decoration-none"}
                                    to={`https://visu.solution-digitale.ch/${result.url}`}
                                    key={index}
                                    target={"_blank"}
                                    onClick={() => setResults([])}  // Clear results on click
                                >
                                    <div
                                        className={"display-flex gap-10 search-item-found justify-content-space-between align-items-center"}>
                                        <div className={"display-flex gap-10 align-items-center"}>
                                            <i className="fa color-third fa-traffic-cone mr-10"></i>
                                            <strong className={"color-primary"}
                                                dangerouslySetInnerHTML={{ __html: result.url }} />
                                        </div>
                                        <div className={"display-flex h-100 gap-10 align-items-center justify-content-center"}>
                                            {result.name_2 && (
                                                <small
                                                    className={"text-right color-third display-flex h-100 p-5 border-radius-5 bg-primary color-white"}
                                                    dangerouslySetInnerHTML={{ __html: result.name_2 }} />
                                            )}
                                            <small
                                                className={"align-items-center color-primary display-flex text-right p-5 border-radius-5 bg-third color-white"} style={{ height: 26 }}
                                                target={"_blank"}
                                                onClick={() => handleLogin('https://visu.solution-digitale.ch/' + result.url)}  // Clear results on click
                                            ><i className={"fas fa-user-shield"} />

                                            </small>
                                        </div>
                                    </div>
                                </NavLink>))}

                        </div>)}
                    </div>
                </div>)}
            </div>
        </div>
    </div>);
};

export default MainSearchBar;
